const UUID_PATTERN = /^\{?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\}?$/i;

/**
 * A `*ByName` field the backend could not resolve, which then carries the raw actor id. An id
 * tells a health manager nothing, so it reads as no name at all rather than as a name.
 */
export function displayName(name?: string): string | undefined {
  const trimmed = name?.trim();

  return trimmed && !UUID_PATTERN.test(trimmed) ? trimmed : undefined;
}
